import { CreateEditCartUi } from '@/components/Cart/modal/CreateEdit/CreateEditUiModel';
import cacheKeys from '@/data/api/cacheKeys';
import { publishCart, updateCart } from '@/data/api/request/cartRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCartRequestFromUiModel } from '../mapper';

export const useUpdateAndPublish = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (args: {
      cartId: string;
      createEditCartUi: CreateEditCartUi;
    }) => {
      const request = createCartRequestFromUiModel(args.createEditCartUi);
      await updateCart(args.cartId, request);
      await publishCart(args.cartId);
      queryClient.invalidateQueries({ queryKey: [cacheKeys.carts.list] });
    },
  });
};
